<div class="container-fluid" [formGroup]="formArray.controls[group]">
    <div formArrayName="goals" [ngClass]="{ 'invalid-goal': goals.touched && goals.invalid }">
        <label class="font-weight-bold">GOALS</label>
        <div class="goal-content">
            <!--Goal Header-->
            <div class="goal-header">
                <div class="d-inline-block add-container">
                    <acl-ngx-button icon="Add" [compact]="true" [disabled]="this.goals.length >= 2 || isDisabled"
                        variant="static" (click)="addGoal()">
                    </acl-ngx-button>
                </div>
                <div class="d-inline-block reset-container">
                    <acl-ngx-button label=Reset [compact]="true" [disabled]="isDisabled" variant="static"
                        (click)="resetGoal()">
                    </acl-ngx-button>
                </div>
            </div>
            <!--Goal Table-->
            <div class="goal-table">
                <table class="table table-bordered">
                    <thead>
                        <tr>
                            <th scope="col" class="row-rank">Priority</th>
                            <th scope="col" class="row-type">Type</th>
                            <th scope="col" class="row-value">Value</th>
                            <th scope="col" class="row-advance">Advanced</th>
                            <th scope="col" class="row-hard-goal">Hard Goal</th>
                            <th scope="col" class="row-remove"></th>
                        </tr>
                    </thead>
                    <tbody cdkDropList (cdkDropListDropped)="onDrop($event)">
                        <tr *ngFor="let item of goalControls; let j = index" cdkDrag formGroupName="{{j}}">
                            <td class="goal-rank">
                                <span class="form-control">{{j + 1}}</span>
                            </td>
                            <!--Type-->
                            <td class="goal-type">
                                <div class="goal-type-dropdown">
                                    <acl-ngx-select menuWidth="375px" variant="static"
                                        (change)="goalTypeChange($event, j)" [irreversible]="true"
                                        [disabled]="isDisabled" [initialValue]="{'value': selectedGoalType[j]}">
                                        <acl-ngx-option *ngFor="let item of GoalGroupConfigs | keyvalue"
                                            [value]="item.value.label">
                                        </acl-ngx-option>
                                    </acl-ngx-select>
                                </div>
                            </td>
                            <!--Value-->
                            <td class="goal-value">
                                <div class="input-group">
                                    <!-- <acl-ngx-select menuWidth="290px" variant="static"
                                        (change)="onGoalDropdownValueChange($event, j)" [disabled]="isDisabled">
                                        <acl-ngx-option *ngFor="let item of [{'label': 'Rate'}] | keyvalue"
                                            [label]="item.value.label" [value]="item.value.label" [selected]="true">
                                        </acl-ngx-option>
                                    </acl-ngx-select> -->
                                    <span class="form-control">Rate</span>
                                    <div class="input-group-append">
                                        <div class="rate-value">
                                            <div class="input-group-append goal-currency-values"
                                                id="DL-goalPercent{{group+1}}"
                                                *ngIf="selectedGoalValueType[j] === 'Rate'">
                                                <input type="number" min="1" max="100"
                                                    formControlName="deliveryGoalThreshold" class="form-control">
                                                <span class="input-group-text currency-percent-symbol">%</span>
                                            </div>
                                        </div>

                                    </div>
                                </div>
                            </td>
                            <!--Advanced-->
                            <td class="goal-advanced" id="DL-goalViewabilityMeasurement{{group+1}}">
                                <acl-ngx-select menuWidth="375px" variant="static"
                                    *ngIf="selectedGoalType[j] === GoalGroupConfigs.Viewability.label"
                                    (change)="viewabilityMeasurementChange($event, j)" [irreversible]="true"
                                    [disabled]="isDisabled"
                                    [initialValue]="{'value': viewabilityMeasurementId(j).value, 'label': getSelectedViewabilityMeasurement(j).label}">
                                    <acl-ngx-option *ngFor="let item of viewabilityMeasurement | keyvalue"
                                        [label]="item.value.label" [value]="item.key">
                                    </acl-ngx-option>
                                </acl-ngx-select>
                            </td>
                            <!--Hard Goal-->
                            <td class="hard-goal">
                                <acl-ngx-checkbox [disabled]="j === 0 || isDisabled"
                                    [checked]="hardGoalControl(j).value" (change)="updateHardGoal($event, j)">
                                </acl-ngx-checkbox>
                            </td>
                            <td class="goal-remove">
                                <span class="goal-remove-icon" *ngIf="j > 0">
                                    <acl-ngx-button icon="Remove" [disabled]="isDisabled" [compact]="true"
                                        variant="static" (click)="removeGoal(j)">
                                    </acl-ngx-button>
                                </span>
                            </td>

                        </tr>
                        <tr class="empty-row" *ngIf="!goalControls.length">
                            <td colspan="5" class="empty-row-text">Add goals using the button above.</td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
        <div id="info-alert" class="info-alert viewability-msg"
            [hidden]="!selectedGoalType.length || (selectedGoalType[0] !== GoalGroupConfigs.Viewability.label && selectedGoalType[1] !== GoalGroupConfigs.Viewability.label) || !showViewabilityMsg">
            <acl-ngx-banner-message variant="info" hideIcon="true" dismissible="true"
                (close)="showViewabilityMsg = false">
                Enabling Viewabillty adds {{currencySymbol}}{{isMobileAppEnvSelected ? mobileViewabilityCPM :
                videoViewabilityCPM}} to your CPM.
            </acl-ngx-banner-message>
        </div>
        <div class="viewability-partners"
            *ngIf="selectedGoalType[0] === GoalGroupConfigs.Viewability.label || selectedGoalType[1] === GoalGroupConfigs.Viewability.label">
            <h5 class="viewability-partners-title">Viewability Platform</h5>
            <span class="viewability-partner">
                {{ isMobileAppEnvSelected ? (mobileViewabilityPartner && mobileViewabilityPartner.name) :
                (videoViewabilityPartner && videoViewabilityPartner.name)}}
            </span>
            <acl-ngx-tooltip [trigger]=" trigger"
                [text]="'Edit the Advertiser if you would like to change your Viewability Platform Vendor'">
            </acl-ngx-tooltip>
            <ng-template #trigger>
                <acl-ngx-icon [name]="'Help'"></acl-ngx-icon>
            </ng-template>
        </div>
    </div>
    <div *ngIf="goals.touched && goals.value.length && isInvalid()" class="error-feedback">
        <span>Goal Value is required and should be a positive currency amount or a percent value between 1-100</span>
    </div>
    <div *ngIf="goals.touched && goals.value.length && (goalId(0).errors || (goals.value.length > 1 && goalId(1).errors))"
        class="error-feedback">
        <span> The selected goals are currently not supported in a multi-goal configuration </span>
    </div>
</div>
